export default "__VITE_ASSET__C28Fzpex__"